<template>
<div class="bg-white px-3 pb-4 sm:px-4">
    <div class="flex w-full flex-col items-start gap-3 pb-4 sm:flex-row sm:items-center sm:justify-between sm:gap-4">
        <div class="flex flex-col pt-4">
            <h1 class="h6 pl-1">
                <slot name="title" />
            </h1>
            <slot name="breadcrumb" />
        </div>

        <div class="flex flex-wrap gap-2">
            <slot name="actions" />
        </div>
    </div>
    <slot />
</div>
</template>

<script>
export default {
    inheritAttrs: false,
};
</script>
